import { render, staticRenderFns } from "./company-account.vue?vue&type=template&id=2f1b93cd&scoped=true&"
import script from "./company-account.vue?vue&type=script&lang=js&"
export * from "./company-account.vue?vue&type=script&lang=js&"
import style0 from "./company-account.vue?vue&type=style&index=0&id=2f1b93cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1b93cd",
  null
  
)

export default component.exports